import styled from "styled-components";

export const AccountantFinancialsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem;

  @media (max-width: ${({ theme }) => theme.screen.mobile}) {
    padding: 2rem 0.5rem;
  }

  .export-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    margin-bottom: 1rem;

    .select-wrapper {
      width: 200px;
    }
  }

  .card-wrapper {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 2rem;

    @media (min-width: ${({ theme }) => theme.screen.tablet}) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media screen and (min-width: ${({ theme }) => theme.screen.smallScreen}) {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  .top-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }

  .table {
    width: 100%;
    margin-top: 2rem;

    @media (min-width: ${({ theme }) => theme.screen.tablet}) {
      margin-top: 5rem;
    }

    @media screen and (min-width: ${({ theme }) => theme.screen.smallScreen}) {
      margin-top: 5rem;
      /* padding-top: 5rem; */
    }
  }

  .table-wrapper {
    width: 100%;
  }
`;

export const AccountantAuditWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem;

  @media (max-width: ${({ theme }) => theme.screen.mobile}) {
    padding: 2rem 0.5rem;
  }

  .cta-financials {
    width: 100%;
    display: flex;
    gap: 10px;
    justify-content: flex-end;
  }

  .top-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }

  .table {
    width: 100%;
    margin-top: 2rem;

    @media (min-width: ${({ theme }) => theme.screen.tablet}) {
      margin-top: 5rem;
    }

    @media screen and (min-width: ${({ theme }) => theme.screen.smallScreen}) {
      margin-top: 5rem;
      /* padding-top: 5rem; */
    }
  }

  .table-wrapper {
    width: 100%;
  }
`;
